import type { CoturnCredentials } from '@/types/organization/CoturnCredentials';

export abstract class OrganizationService {
  abstract getCoturnCredentials(organizationId: string): Promise<CoturnCredentials>;
}
